import React from 'react';
import { Stethoscope, Send, ArrowLeft } from 'lucide-react';

const ConsultationPage = ({ setCurrentPage }) => {
  const inputClass =
    'mt-1.5 block w-full rounded-xl border-2 border-gray-200 px-4 py-2.5 outline-none transition-colors duration-200 focus:border-[#10B981]';
  const labelClass = 'block text-sm font-semibold text-gray-700';

  return (
    <div className="min-h-screen bg-gray-50 font-['Cairo']">
      <div className="container mx-auto px-4 py-16 lg:py-24">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#10B981]/10">
            <Stethoscope className="h-8 w-8 text-[#10B981]" />
          </div>
          <h2 className="mb-4 text-3xl font-bold text-gray-900 lg:text-4xl">استشارة طبية</h2>
          <p className="text-lg text-gray-600">
            اكتب استفسارك الطبي وسيقوم فريقنا من الصيادلة والخبراء بالرد عليك في أقرب وقت ممكن.
          </p>
        </div>

        <div className="mx-auto max-w-2xl rounded-2xl bg-white p-8 shadow-md ring-1 ring-gray-100">
          <form className="space-y-6">
            <div>
              <label htmlFor="name" className={labelClass}>
                الاسم الكامل
              </label>
              <input type="text" id="name" name="name" className={inputClass} placeholder="أدخل اسمك" />
            </div>
            <div>
              <label htmlFor="email" className={labelClass}>
                البريد الإلكتروني
              </label>
              <input type="email" id="email" name="email" className={inputClass} placeholder="example@email.com" />
            </div>
            <div>
              <label htmlFor="message" className={labelClass}>
                رسالتك أو استفسارك
              </label>
              <textarea
                id="message"
                name="message"
                rows="6"
                className={`${inputClass} resize-none`}
                placeholder="صف حالتك أو اكتب سؤالك هنا..."
              ></textarea>
            </div>
            <div className="flex flex-col-reverse items-center gap-4 pt-2 sm:flex-row sm:justify-between">
              <button
                type="button"
                onClick={() => setCurrentPage('home')}
                className="flex items-center gap-1.5 font-semibold text-gray-500 transition-colors duration-200 hover:text-[#10B981]"
              >
                <ArrowLeft className="h-4 w-4" />
                العودة إلى الصفحة الرئيسية
              </button>
              <button
                type="submit"
                className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#10B981] px-8 py-3.5 font-bold text-white shadow-sm shadow-[#10B981]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#0ea173] hover:shadow-lg hover:shadow-[#10B981]/25 active:translate-y-0 sm:w-auto"
              >
                <Send className="h-4 w-4" />
                إرسال الاستشارة
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConsultationPage;
